<template>
  <div>
    <div class="panel panel-default" id="approval-top-panel">
      <div class="panel-body top-button-bar">
        <div class="col-md-12">
          <button class="btn btn-raised btn-top-bar" @click="getApprovalData()">
            <i class="material-icons md-36">refresh</i>
            <br />
            {{ lang.SA0000 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="globals.isLocalAgencyUser"
            @click="getApprovalData(() => (showShopperProposalModal = true))"
            :disabled="!isSelectedCheckOnCurrentPage"
          >
            <i class="material-icons md-36">person_add</i>
            <br />
            {{ lang.SA0001 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="!globals.isAgencyUser || globals.isLeadAgencyUser"
            @click="getApprovalData(() => (showShopperApprovalModal = true))"
            :disabled="
              !isSelectedCheckOnCurrentPage || !selectedCheck.ShopperProposals
            "
          >
            <i class="material-icons md-36">assignment_turned_in</i>
            <br />
            {{ lang.SA0002 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            v-if="!globals.isAgencyUser"
            @click="showCarModelManagement = true"
          >
            <i class="material-icons md-36">drive_eta</i>
            <br />
            {{ lang.SA0003 }}
          </button>
          <button
            class="btn btn-raised btn-top-bar"
            @click="
              getApprovalData(),
                globals.$emit('showApprovalWaveStatus', selectedCheck)
            "
          >
            <i class="material-icons md-36">insert_chart</i>
            <br />
            {{ lang.SA0004 }}
          </button>
        </div>
      </div>

      <div class="panel-body">
        <div class="col-lg-6">
          <div class="form-group searchbar">
            <input
              type="search"
              class="form-control"
              :placeholder="lang.SA0005"
              v-model="filterStrings.Search"
              @keyup.enter="(selectedPage = 1), getApprovalData()"
            />
          </div>
        </div>

        <div class="col-lg-6 nopadding">
          <ul class="pagination-fonts pagination btn-group">
            <li>
              <a
                role="button"
                class="dropdown-toggle"
                data-toggle="dropdown"
                id="elementsPerPageDropdown"
              >
                <i class="material-icons md-18">view_headline</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="elementsPerPageDropdown"
                :delay="globals.tooltipDelay"
                >{{ lang.SA0006 }}</b-tooltip
              >
              <ul class="dropdown-menu">
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize === 20 }"
                    role="button"
                    @click="updatePaging(1, 20)"
                    >20</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize === 50 }"
                    role="button"
                    @click="updatePaging(1, 50)"
                    >50</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize === 100 }"
                    role="button"
                    @click="updatePaging(1, 100)"
                    >100</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize === 200 }"
                    role="button"
                    @click="updatePaging(1, 200)"
                    >200</a
                  >
                </li>
                <li>
                  <a
                    class="dropdown-element"
                    v-bind:class="{ 'dropdown-active': pageSize === 500 }"
                    role="button"
                    @click="updatePaging(1, 500)"
                    >500</a
                  >
                </li>
              </ul>
            </li>

            <li
              v-bind:class="{ disabled: !pageCount || selectedPage === 1 }"
              @click="updatePaging(1, 0)"
            >
              <a role="button" id="firstPageButton">
                <i class="material-icons md-18">first_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="firstPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SA0007 }}</b-tooltip
              >
            </li>
            <li v-if="pageCount > 7 && selectedPage > 4" class="disabled">
              <a role="button">...</a>
            </li>
            <li
              v-for="pageNumber in getVisiblePages()"
              :key="pageNumber"
              v-bind:class="{ active: selectedPage === pageNumber }"
              @click="updatePaging(pageNumber)"
            >
              <a role="button">{{ pageNumber }}</a>
            </li>
            <li
              v-if="pageCount > 7 && selectedPage < pageCount - 3"
              class="disabled"
            >
              <a role="button">...</a>
            </li>
            <li
              v-bind:class="{
                disabled: !pageCount || selectedPage === pageCount,
              }"
              @click="updatePaging(pageCount)"
            >
              <a role="button" id="lastPageButton">
                <i class="material-icons md-18">last_page</i>
              </a>
              <b-tooltip
                ref="tooltip"
                target="lastPageButton"
                :delay="globals.tooltipDelay"
                >{{ lang.SA0008 }}</b-tooltip
              >
            </li>
            <li class="disabled">
              <a role="button" id="approvalTotalElementsCounter">{{
                checkCount
              }}</a>
              <b-tooltip
                ref="tooltip"
                target="approvalTotalElementsCounter"
                :delay="globals.tooltipDelay"
                >{{ lang.SA0009 }}</b-tooltip
              >
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="panel panel-default">
      <div class="panel-body">
        <div class="table-space main-table-scrollbar">
          <table
            class="table table-striped table-hover main-table"
            id="approvalMainTable"
          >
            <thead>
              <tr>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('SurveyId')"
                  >
                    {{ lang.SA0010 }}
                    <span
                      v-if="sortField == 'SurveyId' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'SurveyId' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('SurveyInstanceId')"
                  >
                    {{ lang.SA0011 }}
                    <span
                      v-if="
                        sortField == 'SurveyInstanceId' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'SurveyInstanceId' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('ImporterName')"
                  >
                    {{ lang.SA0012 }}
                    <span
                      v-if="sortField == 'ImporterName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'ImporterName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('WaveName')"
                  >
                    {{ lang.SA0013 }}
                    <span
                      v-if="sortField == 'WaveName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'WaveName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('LocationStoreId')"
                  >
                    {{ lang.SA0014 }}
                    <span
                      v-if="
                        sortField == 'LocationStoreId' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationStoreId' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('LocationName')"
                  >
                    {{ lang.SA0015 }}
                    <span
                      v-if="sortField == 'LocationName' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LocationName' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('LocationCity')"
                  >
                    {{ lang.SA0016 }}
                    <span
                      v-if="sortField == 'LocationCity' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LocationCity' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('LocationCountry')"
                  >
                    {{ lang.SA0017 }}
                    <span
                      v-if="
                        sortField == 'LocationCountry' && sortOrder == 'asc'
                      "
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="
                        sortField == 'LocationCountry' && sortOrder == 'desc'
                      "
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('DealerGroup')"
                  >
                    {{ lang.SA0018 }}
                    <span
                      v-if="sortField == 'DealerGroup' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'DealerGroup' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('Brand')"
                  >
                    {{ lang.SA0019 }}
                    <span
                      v-if="sortField == 'Brand' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'Brand' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header">
                  <a
                    class="table-header"
                    role="button"
                    @click="sortCheckData('LastUpdatedAt')"
                  >
                    {{ lang.SA0020 }}
                    <span
                      v-if="sortField == 'LastUpdatedAt' && sortOrder == 'asc'"
                      class="glyphicon glyphicon-triangle-top"
                    ></span>
                    <span
                      v-if="sortField == 'LastUpdatedAt' && sortOrder == 'desc'"
                      class="glyphicon glyphicon-triangle-bottom"
                    ></span>
                  </a>
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0021 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0022 }} ({{ lang.SA0023 }})
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0024 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0025 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0026 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0027 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0028 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0029 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0030 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0031 }}
                </th>
                <th class="text-center sticky-header unsortable-column-header">
                  {{ lang.SA0032 }}
                </th>
              </tr>
              <tr class="table-filters">
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.SurveyId"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.SurveyInstanceId"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.ImporterName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.WaveName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.LocationStoreId"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.LocationName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.LocationCity"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.LocationCountry"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.DealerGroup"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.Brand"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div
                    class="form-group filterbar"
                    id="inputFilterLastUpdateAtContainer"
                    @click="globals.toggleFlatpickr('inputFilterLastUpdateAt')"
                  >
                    <input
                      type="text"
                      id="inputFilterLastUpdateAt"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                    />
                    <b-tooltip
                      ref="tooltip"
                      target="inputFilterLastUpdateAtContainer"
                      v-if="lastUpdateAtFilterContent"
                      :delay="globals.tooltipDelay"
                      >{{ lastUpdateAtFilterContent }}</b-tooltip
                    >
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.ShopperId"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.DisplayName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.Gender"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.Distance"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.Occupation"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.CarModelName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.CarSegmentName"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <input
                      type="search"
                      class="form-control text-center nopadding"
                      :placeholder="lang.SA0033"
                      v-model="filterStrings.ShopperCar"
                      @keyup.enter="(selectedPage = 1), getApprovalData()"
                    />
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <select
                      class="form-control text-center nopadding"
                      v-model="filterStrings.CarMatch"
                      @change="(selectedPage = 1), getApprovalData()"
                    >
                      <option :value="''">{{ lang.SA0034 }}</option>
                      <option :value="'+'">+ {{ lang.SA0035 }}</option>
                      <option :value="'='">= {{ lang.SA0036 }}</option>
                      <option :value="'-'">- {{ lang.SA0037 }}</option>
                    </select>
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <select
                      class="form-control text-center nopadding"
                      v-model="filterStrings.ApprovedByLeadAgency"
                      @change="(selectedPage = 1), getApprovalData()"
                      :class="{
                        'option-green':
                          filterStrings.ApprovedByLeadAgency === 'Approved',
                        'option-red':
                          filterStrings.ApprovedByLeadAgency === 'Rejected',
                        'option-yellow':
                          filterStrings.ApprovedByLeadAgency === 'Open',
                      }"
                    >
                      <option class="option-white" :value="''">
                        {{ lang.SA0034 }}
                      </option>
                      <option class="option-white" :value="'None'">
                        {{ lang.SA0038 }}
                      </option>
                      <option class="option-green" :value="'Approved'">
                        {{ lang.SA0039 }}
                      </option>
                      <option class="option-yellow" :value="'Open'">
                        {{ lang.SA0040 }}
                      </option>
                      <option class="option-red" :value="'Rejected'">
                        {{ lang.SA0041 }}
                      </option>
                    </select>
                  </div>
                </th>
                <th class="nopadding sticky-filter">
                  <div class="form-group filterbar">
                    <select
                      class="form-control text-center nopadding"
                      v-model="filterStrings.ApprovedByMainEntity"
                      @change="(selectedPage = 1), getApprovalData()"
                      :class="{
                        'option-green':
                          filterStrings.ApprovedByMainEntity === 'Approved',
                        'option-red':
                          filterStrings.ApprovedByMainEntity === 'Rejected',
                        'option-yellow':
                          filterStrings.ApprovedByMainEntity === 'Open',
                      }"
                    >
                      <option class="option-white" :value="''">
                        {{ lang.SA0034 }}
                      </option>
                      <option class="option-white" :value="'None'">
                        {{ lang.SA0038 }}
                      </option>
                      <option class="option-green" :value="'Approved'">
                        {{ lang.SA0039 }}
                      </option>
                      <option class="option-yellow" :value="'Open'">
                        {{ lang.SA0040 }}
                      </option>
                      <option class="option-red" :value="'Rejected'">
                        {{ lang.SA0041 }}
                      </option>
                    </select>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <template v-for="check in approvalData">
                <tr
                  role="button"
                  :key="check.SurveyInstanceGuid"
                  @click="selectedCheck = check"
                  :class="{
                    info:
                      check.SurveyInstanceGuid ===
                      selectedCheck.SurveyInstanceGuid,
                  }"
                >
                  <td
                    class="wave-state-indicator"
                    :class="{
                      'state-yellow': check.AudiStatus === 'WaveStarted',
                      'state-orange': check.AudiStatus === 'WaveOneHalfPassed',
                      'state-red':
                        check.AudiStatus === 'WaveTwoThirdsPassed' ||
                        check.AudiStatus === 'ActionRequired',
                    }"
                  ></td>
                  <td
                    :id="`approvalSurveyIdTableData${check.SurveyInstanceGuid}`"
                    style="width: 3%"
                  >
                    {{ check.SurveyId }}
                    <br />
                    <i class="material-icons md-24">info_outline</i>
                  </td>
                  <b-tooltip
                    ref="tooltip"
                    :target="`approvalSurveyIdTableData${check.SurveyInstanceGuid}`"
                    :delay="globals.tooltipDelay"
                  >
                    <div class="survey-id-info-tooltip">
                      <b>{{ lang.SA0042 }}:</b>
                      {{ check.SurveyTitle }}
                      <br />
                      <b>{{ lang.SA0043 }}:</b>
                      {{ check.ProjectName }}
                      <br />
                      <b>{{ lang.SA0044 }}:</b>
                      {{ check.ScenarioName }}
                    </div>
                  </b-tooltip>
                  <td style="width: 4%">{{ check.SurveyInstanceId }}</td>
                  <td style="width: 5%">{{ check.ImporterName }}</td>
                  <td
                    :id="`approvalWaveNameTableData${check.SurveyInstanceGuid}`"
                    style="width: 5%"
                  >
                    {{ check.WaveName }}
                    <br />
                    <i
                      v-if="check.CarModelDistribution"
                      class="material-icons md-24"
                      >info_outline</i
                    >
                  </td>
                  <b-tooltip
                    ref="tooltip"
                    v-if="
                      check.CarModelDistribution ||
                      check.CompetitorCarModelDistribution
                    "
                    :target="`approvalWaveNameTableData${check.SurveyInstanceGuid}`"
                    :delay="globals.tooltipDelay"
                  >
                    <template v-if="check.CarModelDistribution">
                      <b>{{ lang.SA0045 }}:</b>
                      <br />
                      <span
                        v-for="model in check.CarModelDistribution"
                        :key="model.CarModelGuid"
                      >
                        {{ model.CarModelName }} -
                        {{ model.Distribution * 100 }}%
                        <br />
                      </span>
                    </template>
                    <template
                      v-if="
                        check.CarModelDistribution &&
                        check.CompetitorCarModelDistribution
                      "
                    >
                      <br />
                    </template>
                    <template v-if="check.CompetitorCarModelDistribution">
                      <b>{{ lang.SA0046 }}:</b>
                      <br />
                      <span
                        v-for="model in check.CompetitorCarModelDistribution"
                        :key="model.CompetitorCarModelGuid"
                      >
                        {{ model.CompetitorCarModel }} -
                        {{ model.Distribution * 100 }}%
                        <br />
                      </span>
                    </template>
                  </b-tooltip>
                  <td style="width: 4%">{{ check.LocationStoreId }}</td>
                  <td style="width: 7%">{{ check.LocationName }}</td>
                  <td style="width: 5%">{{ check.LocationCity }}</td>
                  <td style="width: 3%">{{ check.LocationCountry }}</td>
                  <td style="width: 5%">{{ check.DealerGroup }}</td>
                  <td style="width: 5%">{{ check.Brand }}</td>
                  <td
                    style="width: 4%"
                    :id="`approvalDateDiffTableData${check.SurveyInstanceGuid}`"
                  >
                    {{ check.DateDiffLastChangedAt }}
                  </td>
                  <b-tooltip
                    ref="tooltip"
                    :target="`approvalDateDiffTableData${check.SurveyInstanceGuid}`"
                    :delay="globals.tooltipDelay"
                    >{{ check.LastUpdatedAt }}</b-tooltip
                  >

                  <td style="width: 50%" class="nested-table-container">
                    <template v-if="check.ShopperProposals">
                      <table class="nested-table">
                        <tr
                          v-for="proposal in check.ShopperProposals"
                          :key="proposal.ShopperProposalGuid"
                        >
                          <td style="width: 8%">{{ proposal.ShopperId }}</td>
                          <td style="width: 16%">{{ proposal.DisplayName }}</td>
                          <td style="width: 6%">{{ proposal.Gender }}</td>
                          <td style="width: 10%">
                            <span v-if="typeof proposal.Distance === 'number'"
                              >{{ proposal.Distance }} km</span
                            >
                          </td>
                          <td style="width: 14%">{{ proposal.Occupation }}</td>
                          <td style="width: 6%">{{ proposal.CarModelName }}</td>
                          <td style="width: 8%">
                            {{ proposal.CarSegmentName }}
                          </td>
                          <td style="width: 10%">{{ proposal.ShopperCar }}</td>
                          <td style="width: 6%">{{ proposal.CarMatch }}</td>
                          <td style="width: 8%; padding: 6px 0 0 0">
                            <i
                              class="material-icons md-24 nopadding text-green"
                              v-if="
                                proposal.AgencyApprovalStatus === 'Approved'
                              "
                              >done</i
                            >
                            <i
                              class="material-icons md-24 nopadding text-red"
                              v-else-if="
                                proposal.AgencyApprovalStatus === 'Rejected'
                              "
                              >clear</i
                            >
                            <i
                              class="material-icons md-24 nopadding text-yellow"
                              v-else
                              >lens</i
                            >
                          </td>
                          <td style="width: 8%; padding: 6px 0 0 0">
                            <i
                              class="material-icons md-24 nopadding text-green"
                              v-if="
                                proposal.MainEntityApprovalStatus === 'Approved'
                              "
                              >done</i
                            >
                            <i
                              class="material-icons md-24 nopadding text-red"
                              v-else-if="
                                proposal.MainEntityApprovalStatus === 'Rejected'
                              "
                              >clear</i
                            >
                            <i
                              class="material-icons md-24 nopadding text-yellow"
                              v-else
                              >lens</i
                            >
                          </td>
                        </tr>
                      </table>
                    </template>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <ShopperProposalModal
      :showModal="showShopperProposalModal"
      :check="selectedCheck"
      @modalClosed="showShopperProposalModal = false"
      @dataUpdated="getApprovalData()"
    />

    <ShopperApprovalModal
      :showModal="showShopperApprovalModal"
      :check="selectedCheck"
      @modalClosed="showShopperApprovalModal = false"
      @resetData="getApprovalData()"
    />

    <CarModelManagement
      :showModal="showCarModelManagement"
      @modalClosed="showCarModelManagement = false"
    />

    <ApprovalWaveStatusModal></ApprovalWaveStatusModal>
  </div>
</template>

<script>
import ShopperProposalModal from "./ShopperProposalModal";
import ShopperApprovalModal from "./ShopperApprovalModal";
import CarModelManagement from "./CarModelManagement";
import ApprovalWaveStatusModal from "./ApprovalWaveStatusModal";

export default {
  name: "ShopperApproval",
  components: {
    ShopperProposalModal,
    ShopperApprovalModal,
    CarModelManagement,
    ApprovalWaveStatusModal,
  },
  data() {
    return {
      pageSize: 20,
      selectedPage: 1,
      pageCount: 1,
      checkCount: 0,
      sortField: "LastUpdatedAt",
      sortOrder: "desc", // Should be "asc" or "desc"
      selectedCheck: {},
      showShopperProposalModal: false,
      showShopperApprovalModal: false,
      showCarModelManagement: false,
      filterStrings: {
        Search: "",
        SurveyId: "",
        SurveyInstanceId: "",
        ImporterName: "",
        ProjectName: "",
        WaveName: "",
        ScenarioName: "",
        LocationStoreId: "",
        LocationName: "",
        LocationAddress: "",
        LocationCity: "",
        LocationCountry: "",
        DealerGroup: "",
        Brand: "",
        LastUpdatedAt: [],
        ShopperId: "",
        DisplayName: "",
        Occupation: "",
        Gender: "",
        Distance: "",
        CarSegmentName: "",
        CarModelName: "",
        ShopperCar: "",
        CarMatch: "",
        ApprovedByLeadAgency: "",
        ApprovedByMainEntity: "",
      },
      lastUpdateAtFilterContent: "",
      fpFilterLastUpdateAt: null,
      approvalData: [],
      lang: {
        SA0000: "Refresh",
        SA0001: "Proposals",
        SA0002: "Approvals",
        SA0003: "Car Models",
        SA0004: "Wave Status",
        SA0005: "Search...",
        SA0006: "Elements per page",
        SA0007: "First page",
        SA0008: "Last page",
        SA0009: "Total checks count",
        SA0010: "SID",
        SA0011: "CheckID",
        SA0012: "Importer",
        SA0013: "Wave",
        SA0014: "StoreID",
        SA0015: "Location",
        SA0016: "City",
        SA0017: "Country",
        SA0018: "Group",
        SA0019: "Brand",
        SA0020: "Updated (days ago)",
        SA0021: "ShopperID",
        SA0022: "Name",
        SA0023: "Age",
        SA0024: "Gender",
        SA0025: "Distance",
        SA0026: "Profession",
        SA0027: "Model",
        SA0028: "Segment",
        SA0029: "Car",
        SA0030: "Match",
        SA0031: "Lead",
        SA0032: "Audi",
        SA0033: "Filter",
        SA0034: "any",
        SA0035: "Upgrade",
        SA0036: "Match",
        SA0037: "Downgrade",
        SA0038: "none",
        SA0039: "approved",
        SA0040: "open",
        SA0041: "rejected",
        SA0042: "Survey title",
        SA0043: "Project",
        SA0044: "Scenario",
        SA0045: "Audi car model distribution",
        SA0046: "Competitor car distribution",
        SA0047: "Approval data request failed",
      },
    };
  },
  computed: {
    isSelectedCheckOnCurrentPage() {
      if (!this.selectedCheck.SurveyInstanceGuid) return false;
      return (
        _.findIndex(
          this.approvalData,
          (check) =>
            check.SurveyInstanceGuid === this.selectedCheck.SurveyInstanceGuid
        ) > -1
      );
    },
  },
  watch: {
    "globals.selectedLanguage"() {
      this.globals.getLanguageStrings(this, this.setElementHeights);
    },
  },
  mounted() {
    this.readComponentSettingsFromStore();
    if (this.globals.selectedLanguage) this.globals.getLanguageStrings(this);

    let initUpdatedAtFilter = () => {
      if (this.fpFilterLastUpdateAt) this.fpFilterLastUpdateAt.destroy();
      let fpConfig = _.cloneDeep(this.globals.flatpickrDateConfig);
      fpConfig.mode = "range";
      fpConfig.onChange = (selectedDates, dateStr, instance) => {
        if (selectedDates.length === 1) return;
        this.filterStrings.LastUpdatedAt = [];
        if (selectedDates.length === 2)
          this.filterStrings.LastUpdatedAt = [
            this.globals.getIsoDateFromIsoTimestamp(selectedDates[0]),
            this.globals.getIsoDateFromIsoTimestamp(selectedDates[1]),
          ];

        this.lastUpdateAtFilterContent = instance.altInput.value;
        this.getApprovalData();
      };
      this.fpFilterLastUpdateAt = flatpickr(
        "#inputFilterLastUpdateAt",
        fpConfig
      );
      if (
        this.filterStrings.LastUpdatedAt &&
        this.filterStrings.LastUpdatedAt.length === 2
      ) {
        this.fpFilterLastUpdateAt.setDate(this.filterStrings.LastUpdatedAt);
        this.lastUpdateAtFilterContent = this.fpFilterLastUpdateAt.altInput.value;
      }

      this.getApprovalData();
    };

    if (this.globals.selectedLanguage) {
      this.globals.getLanguageStrings(this, this.setElementHeights);
      initUpdatedAtFilter();
    }
    this.globals.$off("languageUpdated");
    this.globals.$on("languageUpdated", initUpdatedAtFilter);

    $(window).on("resize", this.setElementHeights).resize();
  },
  destroyed() {
    $(window).off("resize", this.setElementHeights);
    this.writeComponentSettingsToStore();
    if (this.fpFilterLastUpdateAt) this.fpFilterLastUpdateAt.destroy();
  },
  methods: {
    setElementHeights() {
      let height = $(window).height();
      height -=
        $("#approval-top-panel").height() +
        $("#app-navbar").height() +
        // $(".main-table > thead").height() +
        47; // 47 pixel for the free space around the cards
      $(".main-table-scrollbar").css("max-height", height);
      $(".table-space").css("max-height", height);

      //Sets top-property for filter, so it doesnt scroll over table-header
      height = $(".main-table thead tr").height();
      $(".sticky-filter").css("top", height);
    },
    readComponentSettingsFromStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      let storedData = this.$store.getters["localFilters/shopperApproval"];
      if (storedData) {
        for (let key in storedData) {
          if (_.has(this, key)) this[key] = _.cloneDeep(storedData[key]);
        }
      }

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      let storedImporter = this.$store.getters["sharedFilters/importer"];
      this.filterStrings.ImporterName = storedImporter.ImporterName || "";

      // let storedProject = this.$store.getters["sharedFilters/project"];
      // this.filterStrings.ProjectName = storedProject.ProjectName || "";
    },
    writeComponentSettingsToStore() {
      if (!this.$store.getters["userSettings/rememberFilters"]) return;
      this.$store.commit("localFilters/shopperApproval", {
        filterStrings: this.filterStrings,
        sortField: this.sortField,
        sortOrder: this.sortOrder,
        pageSize: this.pageSize,
      });

      if (!this.$store.getters["userSettings/syncFilters"]) return;
      let storedImporter = this.$store.getters["sharedFilters/importer"];
      if (storedImporter.ImporterName !== this.filterStrings.ImporterName) {
        this.$store.commit("sharedFilters/importer", {
          ImporterName: this.filterStrings.ImporterName,
        });
      }
      // let storedProject = this.$store.getters["sharedFilters/project"];
      // if (storedProject.ProjectName !== this.filterStrings.ProjectName) {
      //   this.$store.commit("sharedFilters/project", {
      //     ProjectName: this.filterStrings.ProjectName
      //   });
      // }
    },
    getApprovalData(callback) {
      let query = `api/Approval/Get?page_size=${this.pageSize}&page=${this.selectedPage}&sort_column=${this.sortField}&sort_order=${this.sortOrder}`;

      let body = { Filter: {} };
      for (let key in this.filterStrings) {
        if (this.filterStrings[key].length > 0)
          body.Filter[key] = this.filterStrings[key];
      }

      $.ajax({
        method: "POST",
        url: query,
        data: _.isEmpty(body.Filter) ? "" : JSON.stringify(body),
        dataType: "json",
        contentType: "application/json; charset=utf-8",
        success: (data) => {
          if (data.Error || !data[0]) {
            this.globals.showErrorSnackbar(data.Error || "");
            data.Error && console.error(data.Error);
            return;
          }

          this.approvalData = data[0].Approvals;
          this.pageCount = data[0].Page_Count;
          this.checkCount = data[0].Count;

          let selected = _.find(
            this.approvalData,
            (check) =>
              check.SurveyInstanceGuid === this.selectedCheck.SurveyInstanceGuid
          );
          if (selected) this.selectedCheck = selected;
          if (callback) callback();
        },
        error: (error) => {
          console.error("Error on POST in getApprovalData()");
          this.globals.showErrorSnackbar(this.lang.SA0047);
        },
      });
    },
    sortCheckData(field) {
      if (field === this.sortField) {
        this.sortOrder === "asc"
          ? (this.sortOrder = "desc")
          : (this.sortOrder = "asc");
      } else {
        this.sortField = field;
        this.sortOrder = "asc";
      }
      this.selectedPage = 1;
      this.getApprovalData();
      this.$nextTick(() => {
        this.setElementHeights();
      });
    },
    updatePaging(pageNumber, pageSize) {
      this.selectedPage = pageNumber || 1;
      if (pageSize) this.pageSize = pageSize;
      this.getApprovalData();
    },
    getVisiblePages() {
      if (this.pageCount <= 7) {
        return _.range(1, this.pageCount + 1, 1);
      } else if (this.pageCount > 7 && this.selectedPage <= 4) {
        return _.range(1, 7, 1);
      } else if (
        this.pageCount > 7 &&
        this.selectedPage >= this.pageCount - 3
      ) {
        return _.range(this.pageCount - 5, this.pageCount + 1, 1);
      } else {
        return _.range(this.selectedPage - 2, this.selectedPage + 3, 1);
      }
    },
  },
};
</script>

<style>
#approvalMainTable {
  font-size: 12px;
}

#approvalMainTable .filterbar > input,
#approvalMainTable .filterbar > select {
  max-height: 35px;
  font-size: 12px;
}
#approvalMainTable .filterbar > input::placeholder {
  font-size: 12px;
}
</style>

<style scoped>
.main-table th {
  padding: 3px;
}
.main-table td {
  padding: 4px 6px;
}

.unsortable-column-header {
  color: darkgrey;
}

.nested-table-container {
  padding: 0 !important;
}
.nested-table {
  width: 100%;
}
.nested-table > tr > td {
  text-align: center;
}

.text-yellow {
  color: rgb(228, 228, 110) !important;
}

.option-green {
  background-color: rgb(154, 236, 154) !important;
}
.option-yellow {
  background-color: rgb(228, 228, 110) !important;
}
.option-red {
  background-color: rgb(238, 155, 155) !important;
}
.option-white {
  background-color: white !important;
}

.main-table-scrollbar > tr {
  position: relative;
}
.main-table .wave-state-indicator {
  position: absolute;
  left: 0;
  height: 100%;
  width: 7px;
  margin: 0px;
  padding: 0px;
}
.state-yellow {
  background-color: yellow !important;
}
.state-orange {
  background-color: orange !important;
}
.state-red {
  background-color: red !important;
}

.survey-id-info-tooltip {
  line-height: 1.4em;
}
</style>



// WEBPACK FOOTER //
// ShopperApproval.vue?32cd13ae